<template>
  <div
    class="col text-center items-center fit q-my-lg q-px-md q-px-md-lg"
    style="clear: both; line-height: 1.5em;"
  >
    <h5 class="q-my-none">
      <q-icon name="fa fa-hourglass-start" />
    </h5>
    <div
      v-dompurify-html="$t(textPath, {date: salesStart})"
      :data-test="CypressTarget('eventInformationNotOnSale')"
      class="q-my-none text-bold"
      style="line-height: 1.5em"
    />
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import {
    TICKET_EVENT_NAME,
  } from 'constants/vueRouter/ticket';

  export default {
    name: 'StatusEventNotOnSale',
    props: {
      startSaleDate: {
        type: [Date, Object, String],
        required: false,
        default: '',
      },
      startPreSaleDate: {
        type: [Date, Object, String],
        required: false,
        default: '',
      },
      isOnPreSale: {
        type: Boolean,
        default: false,
      },
      isSalesOpen: {
        type: Boolean,
        required: false,
        default: null,
      },
      eventCode: {
        type: [String, Number],
        required: false,
        default: null,
      },
    },
    data: () => ({
      salesOpeninterval: null,
    }),
    computed: {
      preSaleStartDate() {
        return this.startPreSaleDate ? new Date(this.startPreSaleDate) : null;
      },
      textPath() {
        if (this.preSaleStartDate && this.preSaleStartDate > new Date()) {
          return 'text.preSales.notStarted';
        }

        return 'text.sales.notStarted';
      },
      salesStart() {
        const date = (this.preSaleStartDate && this.preSaleStartDate > new Date())
          ? this.startPreSaleDate
          : this.startSaleDate;
        const navigatorLanguage = navigator.language;
        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        };

        return new Intl.DateTimeFormat(navigatorLanguage, options).format(new Date(date));
      },
    },
    async beforeMount() {
      this.fetchData();
    },
    beforeDestroy() {
      clearInterval(this.salesOpeninterval);
    },
    methods: {
      ...mapActions('ticketSale', [
        'getEventInformation',
      ]),
      async fetchData() {
        const eventData = await (new Promise((resolve) => {
          this.salesOpeninterval = setInterval(() => {
            const data = this.getEventInformation({ eventCode: this.eventCode });
            if (data) {
              resolve(data);
            }
          }, 30000);
        }));
        if (eventData?.is_sales_open === true) { // eslint-disable-line complexity, camelcase
          this.$router.replace({ name: TICKET_EVENT_NAME });
        }
      },
    },
  };
</script>
